import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: '',
  async getComponent () {
    const {
      default: ShopifyContainer
    } = await import(/* webpackChunkName: "shopify-container" */ './containers/ShopifyContainer')
      .catch(handleChunkLoadError);
    return ShopifyContainer;
  }
});
